import { render } from "./AppNavbar.vue?vue&type=template&id=748357a8"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__